import * as React from 'react';
import moment from 'moment';
import { ElectionState } from '../../_generatedTypes.g';
import { Translator } from '../../Translator';
import { turnoutPercentage } from '../../Election';

export default (props: { election: ElectionState, t: Translator, isAdmin: boolean }) => {
    const { election, t } = props;
    return <>
<h1 className="election__name">{t.translate(election.Name)}</h1>
{t.translate(election.Description) && <p className="election__description">{t.translate(election.Description)}</p>}
<table className="election__details">
    <tbody>
    <tr>
        <th>{t['Open date']}</th><td>{moment(election.VoteOpenMoment).format('LLL')}</td>
    </tr>
    <tr>
        <th>{t['Closing date']}</th><td>{moment(election.VoteCloseMoment).format('LLL')}</td>
    </tr>
    <tr>
        <th>{t['Turnout']}</th><td>{t.formatTurnout(turnoutPercentage(election), t.localeCode, '')}</td>
    </tr>
    <tr>
        <th>{t['Seat count']}</th><td>{election.SeatCount}</td>
    </tr>
    {props.isAdmin && <tr>
            <th>{t['Election Code']}</th><td>{election.Code}</td>
        </tr>}
    </tbody>
</table>
</>
}
